import React, { FC, useMemo } from 'react';
import { FieldSection, FieldSectionType } from 'api/field-sections/types';
import { Field } from 'api/tasks';
import { SortableSectionList } from './sortable-section-list';
import { computeSectionFieldMapping } from './utils';

export interface FieldSectionMapping extends Omit<FieldSection, 'fieldOrder'> {
  fieldOrder: Field[];
}
interface Props {
  fieldList: Field[];
  fieldSections: FieldSection[];
  fieldSectionType: FieldSectionType;
}
export const FieldSectionList: FC<Props> = ({
  fieldList,
  fieldSections,
  fieldSectionType,
}) => {
  const fieldSectionMapping = useMemo(() => {
    return computeSectionFieldMapping(fieldList, fieldSections);
  }, [fieldList, fieldSections]);

  return (
    <SortableSectionList
      sectionList={fieldSectionMapping}
      sectionType={fieldSectionType}
    />
  );
};
